(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MainDashboardV2Controller', MainDashboardV2Controller);

    MainDashboardV2Controller.$inject = ['__config', '$scope', '$state', '$interval', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'CompanyCustom', 'ServiceItemCustom', '$translatePartialLoader', '$translate', 'ServiceCategoryCustom', 'OrderBagServiceItemCustom', 'NewsCustom', '$uibModal', '$rootScope', 'Principal', 'UserCustom', '$translate', 'ActivityTypeInfoCustom', '$timeout', '$localStorage'];

    function MainDashboardV2Controller(__config, $scope, $state, $interval, ParseLinks, AlertService, CompanyCustomerCustom, CompanyCustom, ServiceItemCustom, translatePartialLoader, translate, ServiceCategoryCustom, OrderBagServiceItemCustom, NewsCustom, $uibModal, $rootScope, Principal, UserCustom, $translate, ActivityTypeInfoCustom, $timeout, $localStorage) {
        var vm = this;

        vm.loadPage = loadPage;
        // vm.nextReserveNumber_Func = nextReserveNumber_Func;
        vm.lengthChecker = lengthChecker;
        vm.fadingNumbers = fadingNumbers;

        vm.companyInfoStatus = false;
        vm.companyWorkingTimeStatus = false;
        vm.companySettingStatus = false;
        vm.initialCheck = null;
        vm.lastWeekReserveNumber = 0;
        vm.lastMonthReserveNumber = 0;
        vm.nextReserveNumber = 0;
        vm.tomorrowReserveCount = 0;
        vm.totalReservesNumber = 0;
        vm.numberOfReservesTitlesCompleted = 0;
        vm.time = 0;
        vm.timeNew = '';
        vm.tomorrowPeopleCount = 0;
        vm.appMode = __config.appMode;
        vm.slideIndex = 0;
        vm.showSlides = showSlides;
        vm.getNewsTagClass = getNewsTagClass;
        vm.openNewsUrl = openNewsUrl;
        vm.prevNews = prevNews;
        vm.nextNews = nextNews;


        vm.mode = 'PurchasedUser'; // OnBoarding - FreeUser - PurchasedUser
        vm.onStepClick = onStepClick;
        vm.wizardSteps = [];
        vm.companyWizardSteps = null;
        vm.openInfoDialog = openInfoDialog;
        vm.callSupport = callSupport;
        vm.getStepNumberClass = getStepNumberClass;
        vm.getStepTextClass = getStepTextClass;
        vm.editReserve = editReserve;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.skipWizard = skipWizard;
        vm.sendMsgToSupport = sendMsgToSupport;
        vm.isNativeApp = null;


        loadAll();

        function loadAll() {
            loadCompanyInfo();
            getCurrentPersonInfo();
            setInterval(function () {
                showNextHighPriorityNews()
            }, 20000);
        }

        function fillSteps() {

            vm.wizardSteps = [];
            var step1 = {};
            var step2 = {};
            var step3 = {};
            var step4 = {};
            var step5 = {};
            var step6 = {};


            step1.id = 1;
            step1.title = "اضافه کردن خدمات جدید";
            step1.type = "ADD_SERVICE";
            step1.status = "IN_PROGRESS";

            vm.wizardSteps.push(step1);

            step2.id = 2;
            step2.title = "تغییر عکس، رنگ و لوگو سایت شما";
            step2.type = "CHANGE_THEME";
            step2.status = "IN_PROGRESS";
            vm.wizardSteps.push(step2);

            step3.id = 3;
            if (vm.activityTypeInfo && vm.activityTypeInfo.servantType == 'RESOURCE')
                step3.title = "اضافه کردن منابع" + "(" + vm.activityTypeInfo.servantTitle + ") جدید";
            else
                step3.title = "اضافه کردن پرسنل" + "(" + vm.activityTypeInfo.servantTitle + ") جدید";


            step3.type = "ADD_SERVANT";
            step3.status = "IN_PROGRESS";
            vm.wizardSteps.push(step3);

            step4.id = 4;
            step4.title = "تغییر ساعت کاری";
            step4.type = "CHANGE_COMPANY_SCHEDULE";
            step4.status = "IN_PROGRESS";
            vm.wizardSteps.push(step4);

            step5.id = 5;
            step5.title = "اتصال به اینستاگرام";
            step5.type = "CONNECT_INSTAGRAM";
            step5.status = "IN_PROGRESS";
            vm.wizardSteps.push(step5);

            step6.id = 6;
            step6.title = "ثبت اولین رزرو(نوبت) برای مشتری";
            step6.type = "ADD_RESERVE";
            step6.status = "IN_PROGRESS";
            vm.wizardSteps.push(step6);

            vm.activeStepId = 0;
            angular.forEach(vm.wizardSteps, function (item) {
                angular.forEach(vm.companyWizardSteps, function (wStep) {
                    if (item.type == wStep.wizardStepType)
                        item.status = "DONE";
                })
            })

            angular.forEach(vm.wizardSteps, function (item) {
                if (item.status != "DONE" && vm.activeStepId == 0) {
                    vm.activeStepId = item.id;
                }
            })

        }

        function loadPage(page) {

        }

        function loadCompanyInfo() {
            CompanyCustom.getCurrentCompany().get(function (company) {
                vm.company = company;
                ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.company.activityType).query(function (activity) {
                    vm.activityTypeInfo = activity;
                    fillSteps();
                })
                getCompanyOnBoardingMode();


            })
        }

        function getCompanyOnBoardingMode() {
            CompanyCustom.getCurrentCompanyOnBoardingMode().get(function (result) {
                if (result)
                    vm.mode = result.mode;

                getActiveNews();
                loadReserveList();
                loadReserveStats();
                $interval(showSlides, 30000); // Change image every 20 seconds


                if (vm.mode == "OnBoarding") {
                    getCurrentCompanyWizardSteps();
                }

            })
        }

        function getCurrentCompanyWizardSteps() {
            CompanyCustom.getCurrentCompanyWizardSteps().query().$promise.then(function (wizardSteps) {
                if (wizardSteps)
                    vm.companyWizardSteps = wizardSteps;
                fillSteps();
            })
        }

        function lengthChecker(num) {
            if (num > 0 && num <= 10) {
                vm.time = 100;
            } else if (num > 10 && num <= 100) {
                vm.time = 20
            } else if (num > 100 && num <= 200) {
                vm.time = 15
            } else if (num > 200 && num <= 500) {
                vm.time = 10
            } else if (num > 500 && num <= 1000) {
                vm.time = 5
            } else if (num > 1000) {
                vm.time = 1
            }
        }

        function fadingNumbers() {
            if (vm.numberOfReservesTitlesCompleted === 4) {
                for (var i = 1; i <= 6; i++) {
                    $('#lastWeekReserveNumber').fadeToggle();
                    $('#lastMonthReserveNumber').fadeToggle();
                    $('#totalReservesNumber').fadeToggle();
                    // $('#nextReserveNumber').fadeToggle();
                    $('#tomorrowReserveNumber').fadeToggle();
                }
            }
        }


        function getActiveNews() {


            vm.highPriorityNews = [];
            vm.news = [];
            vm.activeHighPriorityNews = null;

            NewsCustom.getActiveNewsByCurrentCompany().query().$promise.then(function (news) {

                    if (news) {
                        if (news.length > 0) {
                            var i = 0;
                            var j = 0;
                            angular.forEach(news, function (newsItem) {


                                if (newsItem.newsType == "WARNING" || newsItem.newsType == "NEW_FEATURE" || newsItem.newsType == "SPECIAL_OFFER") {
                                    newsItem.index = j;
                                    j++;
                                    vm.highPriorityNews.push(newsItem);
                                } else {
                                    newsItem.index = i;
                                    i++;
                                    vm.news.push(newsItem);
                                }

                                showNextHighPriorityNews();

                            });

                            if (vm.news && vm.news.length > 0)
                                vm.activeNews = vm.news[0];

                            // showSlides();
                        }
                    }

                }
            );
        }

        function showSlides() {
            vm.slideIndex++;
            if (vm.slideIndex == vm.news.length) {
                vm.slideIndex = 0
            }
            // vm.activeNews = vm.news[vm.slideIndex];

            angular.forEach(vm.news, function (item) {
                if (item.index == vm.slideIndex) {
                    item.cssClass = 'show-slide'
                    vm.activeNews = item;
                } else {
                    item.cssClass = 'hide-slide'
                }
            });


        }

        function showNextHighPriorityNews() {

            if (!vm.highPriorityNews || vm.highPriorityNews.length == 0)
                return;

            if (!vm.activeHighPriorityNews || vm.highPriorityNews.length == 1) {
                vm.activeHighPriorityNews = vm.highPriorityNews[0];
                return;
            }

            var next = vm.activeHighPriorityNews.index + 1;
            if (next >= vm.highPriorityNews.length)
                next = 0;

            vm.activeHighPriorityNews = vm.highPriorityNews[next];

        }


        function getNewsTagClass(news) {
            if (news && news.newsType) {
                switch (news.newsType) {
                    case 'INFO':
                        return 'news-INFO';
                    case 'HELP':
                        return 'news-HELP';
                    case 'WARNING':
                        return 'news-WARNING';
                    case 'EXPERT_HELP':
                        return 'news-EXPERT_HELP';
                    case 'NEW_FEATURE':
                        return 'news-NEW_FEATURE';
                    case 'SPECIAL_OFFER':
                        return 'news-SPECIAL_OFFER';

                }
            }
        }

        function openNewsUrl(news) {
            if (news && news.actionUrl) {
                window.open(news.actionUrl, '_blank');
            }

        }

        function prevNews() {
            vm.slideIndex--;
            if (vm.slideIndex == -1 && vm.news && vm.news.length > 0) {
                vm.slideIndex = vm.news.length - 1;
            }
            vm.slideIndex--;
            showSlides();
        }

        function nextNews() {
            vm.slideIndex++;
            if (vm.news && vm.news.length == vm.slideIndex) {
                vm.slideIndex = 0;
            }

            showSlides();
        }


        function loadReserveStats() {
            OrderBagServiceItemCustom.getReserveStats().query(function (reserve) {

                vm.tomorrowPeopleCount = reserve.tomorrowPeopleCount;

                setTimeout(function () {
                    $("#analogClock_container").animate({left: "0"});
                }, 1000);

                lengthChecker(reserve.weeklyReserveCount);
                if (reserve.weeklyReserveCount !== 0) {
                    if (reserve.weeklyReserveCount > 10)
                        vm.lastWeekReserveNumber += reserve.weeklyReserveCount - 10;
                    var setInterval = $interval(function myTimer() {


                        if (vm.lastWeekReserveNumber === reserve.weeklyReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }
//////------------

                lengthChecker(reserve.monthlyReserveCount);

                if (reserve.monthlyReserveCount !== 0) {
                    if (reserve.monthlyReserveCount > 10)
                        vm.lastMonthReserveNumber = reserve.monthlyReserveCount - 10;
                    var setInterval2 = $interval(function myTimer() {
                        vm.lastMonthReserveNumber += 1;
                        if (vm.lastMonthReserveNumber === reserve.monthlyReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval2);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }
//////----------

                lengthChecker(reserve.totalReserveCount);
                if (reserve.totalReserveCount !== 0) {
                    if (reserve.totalReserveCount > 10)
                        vm.totalReservesNumber = reserve.totalReserveCount - 10;
                    var setInterval3 = $interval(function myTimer() {

                        vm.totalReservesNumber += 1;
                        if (vm.totalReservesNumber === reserve.totalReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval3);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }
//////----------

                // lengthChecker(reserve.totalReserveCount);
                // if(reserve.activeReserveCount !== 0) {
                //     if(reserve.activeReserveCount>10)
                //         vm.nextReserveNumber = reserve.activeReserveCount-10;
                //     var setInterval4 = $interval(function myTimer() {
                //
                //         vm.nextReserveNumber += 1;
                //         if (vm.nextReserveNumber === reserve.activeReserveCount) {
                //             vm.numberOfReservesTitlesCompleted += 1;
                //             fadingNumbers();
                //             $interval.cancel(setInterval4);
                //         }
                //
                //     }, vm.time);
                // } else {
                //     vm.numberOfReservesTitlesCompleted += 1;
                // }


//////----------

                lengthChecker(reserve.tomorrowReserveCount);
                if (reserve.tomorrowReserveCount !== 0) {
                    if (reserve.tomorrowReserveCount > 10)
                        vm.tomorrowReserveCount = reserve.tomorrowReserveCount - 10;
                    var setInterval5 = $interval(function myTimer() {

                        vm.tomorrowReserveCount += 1;
                        if (vm.tomorrowReserveCount === reserve.tomorrowReserveCount) {
                            vm.numberOfReservesTitlesCompleted += 1;
                            fadingNumbers();
                            $interval.cancel(setInterval5);
                        }

                    }, vm.time);
                } else {
                    vm.numberOfReservesTitlesCompleted += 1;
                }


            });
        }

        function loadReserveList() {
            vm.orderBagServiceItems = [];
            var filter = {};
            filter.maxResult = 10;
            OrderBagServiceItemCustom.searchOrderBagItemsByQuery().save(filter, function (data) {
                vm.orderBagServiceItems = data;

            });

        }

        function onStepClick(step) {

            openInfoDialog(step.type);
            // setStepDone(step);

        }


        function openInfoDialog(type) {
            $uibModal.open({
                templateUrl: 'app/dashboard/company-wizard-step/company-wizard-step.html',
                controller: 'CompanyWizardStepController',
                controllerAs: 'vm',
                // backdrop: 'static',
                size: 'sm',
                windowClass: 'pl-modal-sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            wizardStepType: type,
                            activityTypeInfo: vm.activityTypeInfo
                        };
                    }
                }
            }).result.then(function () {
                getCompanyOnBoardingMode();
            }, function () {

            });

        }

        function getStepNumberClass(step) {
            if (vm.activeStepId == 0)
                return '';
            if (vm.activeStepId == step.id)
                return 'animation-pulsate-fwd step-item-number-active';

        }

        function getStepTextClass(step) {
            if (step.status == 'DONE')
                return 'step-text-done';
        }

        function callSupport() {
            window.open('tel:02191690817');
        }

        function getCurrentPersonInfo() {
            if (Principal.isAuthenticated()) {
                UserCustom.getCurrentUserProfile().query(function (up) {
                    vm.userProfile = up;
                });
            }
        }

        function editReserve(orderBagServiceItem) {
            $state.go('supplierPanel-v2.editOrderBag', {id: orderBagServiceItem.orderBag.id})
        }


        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }

        function skipWizard() {
            CompanyCustom.skipCompanyWizardSteps().save(null, onSkipSuccess, onSkipError);
        }

        function onSkipSuccess(result) {
            getCompanyOnBoardingMode();
        }

        function onSkipError() {

        }

        function sendMsgToSupport() {
            Goftino.toggle();
        }
         $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp
        },10)

    }
})();


